<template lang="html">
  <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	  viewBox="0 0 389.341 389.341" style="enable-background:new 0 0 389.341 389.341;" xml:space="preserve">
  	<g>
      <path d="M389.341,24.25c0-11.782-9.551-21.333-21.333-21.333H21.335c-4.393,0-8.68,1.357-12.273,3.884
        c-9.637,6.778-11.954,20.086-5.176,29.723l125.695,178.702l0.353,130.007c0.022,8.115,2.435,16.044,6.936,22.797
        c12.652,18.979,38.294,24.107,57.273,11.455l44.894-29.929c11.928-7.952,19.066-21.364,18.999-35.699l-0.456-97.845
        L385.383,36.629C387.958,33.014,389.341,28.687,389.341,24.25z M214.851,202.455l0.52,111.599l-42.776,28.518l-0.383-140.901
        L62.423,45.583h264.193L214.851,202.455z"/>
  	</g>
  </svg>
</template>

<script>
export default {
  name: 'Filter'
}
</script>



// WEBPACK FOOTER //
// src/components/primitives/icons/Filter.vue